import { notifyError, notifySuccess } from "../../helpers/helpers";
import { auction } from "../config/urlConfig";

export const confirmLotsPayments = (check, uncheck) => async (dispatch) => {
  dispatch({ type: "PAYMENT_LOTS_LOADING" });
  try {
    dispatch({
      type: "CONFIRM_LOTS_PAYMENTS",
      payload1: check,
      payload2: uncheck,
    });
  } catch (error) {
    notifyError(error.response ? error.response?.data : error.message, error.response?.status);
    dispatch({ type: "PAYMENT_LOTS_LOADDED" });
  }
};

export const PayDeposit = (offer, id, navigate) => async (dispatch) => {
  dispatch({ type: "DEPOSIT_LOADING" });
  try {
    const { data } = await auction.put(
      `/auction/update/pay-deposit/${id}`,
      offer
    );
    navigate(-1);
    notifySuccess("Your Payment was successful.");
    dispatch({ type: "PAY_DEPOSIT", payload: data });
  } catch (error) {
    notifyError(error.response ? error.response?.data : error.message, error.response?.status);
    dispatch({ type: "DEPOSIT_LOADED" });
  }
};
